import EventEmitter from 'events';

class LoaderService extends EventEmitter {
  showLoader() {
    this.emit('change', true);
  }

  hideLoader() {
    this.emit('change', false);
  }
}

export const loaderService = new LoaderService();
